import { render, staticRenderFns } from "./view-user.vue?vue&type=template&id=3fde1b9a&scoped=true"
import script from "./view-user.vue?vue&type=script&lang=js"
export * from "./view-user.vue?vue&type=script&lang=js"
import style0 from "./view-user.vue?vue&type=style&index=0&id=3fde1b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fde1b9a",
  null
  
)

export default component.exports